import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
import Button from "@mui/material/Button";
import OwnerImage from "../../../Assets/images/static/Malak_0008.webp";
import StoreImage from "../../../Assets/images/static/Rings_0012.webp";
import StoreImage1 from "../../../Assets/images/static/MJ-1.webp";
import { Helmet } from "react-helmet";
import aboutimg from "../../../Assets/images/store.png";
import { useSelector } from "react-redux";
import { client_name } from "../../../Helpers/request";

const OurStory = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
        <link rel="canonical" href="https://swalesdiamonds.co.uk/aboutus
        " />
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb m-0 mb-md-5">
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Typography color="text.primary">About Us</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Row className="m-auto w-100">
            <div className="rcs_story_content">
              <h2>About Us</h2>
              <p>
              Welcome to Swales, where the artistry of fine jewellery meets the personalised touch of bespoke design. With almost two decades of expertise in gemmology and a passion for crafting exquisite pieces, we're thrilled to bring our unique vision to you.
              </p>
              <p>
              At Swales, we believe that jewellery is more than just an accessory; it's a reflection of individuality, love, and cherished moments. Our mission is to provide you with not just stunning pieces, but with an experience that is as special and unique as the jewellery we create.
              </p>
              <p>
              Our team has dedicated years to understanding the intricacies of gemstones, their properties, and how they can be transformed into timeless treasures. This knowledge forms the foundation of our craftsmanship, ensuring that each piece we offer meets the highest standards of quality and beauty.
              </p>
              <p>However, our dedication to our customers is what truly distinguishes us from others.  We understand that purchasing jewellery is often a deeply personal experience, whether you're celebrating a milestone, expressing love, or simply treating yourself. That's why we're here every step of the way, ready to listen, advise, and create something truly extraordinary just for you.</p>
              <p>We understand that jewellery is more than adornment; it's an expression of your personality, your love, and your journey. That's why we offer a bespoke design service, where dreams are transformed into stunning reality. Collaborating with you, we'll bring your vision to life, turning your dreams into reality with a piece that is as unique as you are. Whether it's an engagement ring that captures the essence of your love story or a necklace that symbolises a cherished memory, we'll work tirelessly to ensure that every detail is perfect.</p>
               
             
            </div>
          </Row>

          <div className="rcs_story_content mt-5 mb-5">
            <Row className="m-auto w-100">
              <Col md={6} xs={12} className="pl-0 pr-4">
                <h2>WHY CHOOSE US</h2>
               <p>
                But our commitment doesn't end with a purchase. At Swales we are driven by a relentless pursuit of customer satisfaction. We believe in building lasting relationships with each and every client, guiding them through every step of their jewellery journey with warmth, expertise, and genuine care. From selecting the perfect piece to after-sales support, we are here to ensure that your experience with us is nothing short of extraordinary.
                </p>
                <p>So, whether you're searching for a timeless classic, a one-of-a-kind statement piece, or a custom creation that speaks to your soul, we invite you to explore our collection and discover the magic of Swales.</p>
              </Col>
              <Col md={6} xs={12}>
                <div className="rcs_our_story_img_main">
                  <Image src={aboutimg} alt="about us image"></Image>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default OurStory;
